import { defineStore } from "pinia";
import { SkillsApi } from "@simbelapp/order-sdk";
import type { ISkillsStore } from "~/utils/interfaces/skills-interfaces";
import { useSDKApi } from "~/composables/api/useSDKApi";
import { MicroserviceEnum } from "~/utils/enums/common.enums";
import { useFeedback } from "~/composables/feedback/useFeedback";

export const useSkillsStore = defineStore("skillsStore", {
  state: (): ISkillsStore => {
    return {
      skills: [],
    };
  },
  getters: {},
  actions: {
    async fetchSkills() {
      const feedback = useFeedback();
      try {
        const apiInstance = await useSDKApi(MicroserviceEnum.ORDERS, SkillsApi);
        this.skills = await apiInstance.getSkills();
      } catch {
        feedback.error("Une erreur est survenue", "small");
      }
    },
  },
});
